import { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatError } from "@/context/AuthContext";

export default function PasswordAdmin() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (form.new_password.length < 6) return toast.error("New password must be at least 6 characters");
    if (form.new_password !== form.confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated successfully");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(formatError(err.response?.data?.detail) || "Failed"); }
    finally { setLoading(false); }
  };

  const inp = "w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-brand";
  return (
    <div data-testid="admin-password" className="max-w-md">
      <h1 className="text-2xl font-heading font-bold text-navy-heading mb-1">Change Password</h1>
      <p className="text-slate-500 text-sm mb-6">Update your admin account password.</p>
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 space-y-4">
        <div><label className="block text-xs font-semibold text-navy-heading mb-1.5">Current Password</label><input type="password" className={inp} value={form.current_password} onChange={set("current_password")} data-testid="current-password-input" /></div>
        <div><label className="block text-xs font-semibold text-navy-heading mb-1.5">New Password</label><input type="password" className={inp} value={form.new_password} onChange={set("new_password")} data-testid="new-password-input" /></div>
        <div><label className="block text-xs font-semibold text-navy-heading mb-1.5">Confirm New Password</label><input type="password" className={inp} value={form.confirm} onChange={set("confirm")} data-testid="confirm-password-input" /></div>
        <button onClick={save} disabled={loading} className="w-full flex items-center justify-center gap-2 bg-brand text-white font-semibold py-3 rounded-xl disabled:opacity-70" data-testid="change-password-btn">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Update Password</button>
      </div>
    </div>
  );
}
